"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WARNING_HAZARD_CHILD_DEFAULT_TEXT = exports.LASER_SUB_CATEGORIES_FORM_NAMES = exports.LASER_SUB_CATEGORIES = void 0;
exports.LASER_SUB_CATEGORIES = {
    CLASS_RANKS: 'classRanks',
    TYPES: 'types',
    WAVELENGTHS: 'wavelengths',
};
exports.LASER_SUB_CATEGORIES_FORM_NAMES = (_a = {},
    _a[exports.LASER_SUB_CATEGORIES.CLASS_RANKS] = 'laser_class_rank',
    _a[exports.LASER_SUB_CATEGORIES.TYPES] = 'laser_type',
    _a[exports.LASER_SUB_CATEGORIES.WAVELENGTHS] = 'laser_wavelength',
    _a);
exports.WARNING_HAZARD_CHILD_DEFAULT_TEXT = '危険源を選択してください';
